import { Injectable } from "@angular/core";

@Injectable()
export class ImageViewerService {
    imageUrl: string = null;
}
